module.exports = __webpack_public_path__ + "images/stickers/pete-completed@2x.3197b9305f52b722df47.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-completed@2x.png
// module id = lvR1
// module chunks = 1